import { useTranslation } from "i18next-vue";
import { computed } from "vue";
import { useMainStore } from "#/store/main";
import { getGroupsPaidTotal, getPaidModifiersTotal } from "#/utils/freeModifiers";
import { formatPrice } from "#/utils/i18next";

const toNumber = (value: any): number => {
	const num = Number(value);
	return Number.isFinite(num) ? num : 0;
};

const withSizePrice = (modifiers: any[] | undefined, size: any) =>
	(modifiers ?? []).map((mod) => ({
		...mod,
		price: toNumber(mod?.sizes?.find((item: any) => item.id === size?.id)?.price ?? mod?.price ?? mod?.old_price),
	}));

export function useComboPrice(comboSelections: any, combo?: any) {
	const mainStore = useMainStore();
	const { t } = useTranslation();

	const calculateComboItemsTotal = (): number => {
		const base = toNumber(combo?.value?.price ?? 0);

		const itemsTotal = (Object.values(comboSelections.value) as any[]).reduce((total: number, selection: any) => {
			if (!selection?.product) return total;

			const { product, size } = selection;
			const positionMod =
				size && size.price_modification !== null && size.price_modification !== undefined
					? toNumber(size.price_modification)
					: toNumber(product.price_modification ?? 0);

			const modifiersTotal =
				getPaidModifiersTotal(null, withSizePrice(selection.modifiers, size)) +
				getGroupsPaidTotal((selection.groupModifiers || []).map((group: any) => ({ ...group, modifiers: withSizePrice(group.modifiers, size) })));

			return total + positionMod + modifiersTotal;
		}, 0);

		return base + itemsTotal;
	};

	const comboTotal = computed(() => calculateComboItemsTotal());
	const buttonText = computed(() => t("card.button.add-combo", { price: formatPrice(Number(comboTotal.value) || 0, mainStore.config_lib?.currency_symbol) }));

	return { comboTotal, buttonText, calculateComboItemsTotal };
}